import React, { createContext, memo, useCallback, useState } from "react"

interface TabsContextValue {
  activeTabId?: string
  defaultActiveTabId?: string
  tabsIdList: string[]
  setTabsIdList: (value: string[]) => void
  onActiveTabIdChange: (value: string) => void
}

export const TabsContext = createContext<TabsContextValue>({} as TabsContextValue)

/* Root */

interface TabsProps {
  defaultActiveTabId?: string
  children: React.ReactNode
}

const Tabs = (props: TabsProps) => {
  const { children, defaultActiveTabId } = props

  const [activeTabId, setActiveTabId] = useState<string>()
  const [tabsIdList, setTabsIdList] = useState<string[]>([])

  const onActiveTabIdChange = useCallback((value: string) => {
    setActiveTabId(value)
  }, [])

  const contextValue = { activeTabId, defaultActiveTabId, tabsIdList, onActiveTabIdChange, setTabsIdList }

  return <TabsContext.Provider value={{ ...contextValue }}>{children}</TabsContext.Provider>
}

export default memo(Tabs)
